import styled, { css } from "styled-components";
import { useDesignTokens, parseSizeToken } from "@boi/react-design-tokens";
import { TickIcon } from "@boi/react-icons";

type ButtonTextWrapperProps = {
  $isDisabled?: boolean;
  $hasSelectedItem: boolean;
};

export const ButtonTextWrapper = styled.div<ButtonTextWrapperProps>`
  ${({ $isDisabled, $hasSelectedItem }) => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return [
      css`
        overflow: hidden;
        color: ${select.button.placeholder.color.base};
      `,
      $isDisabled &&
        css`
          color: ${select.button.placeholder.color.disabled};
        `,
      $hasSelectedItem &&
        css`
          color: ${select.button.text.color.base};
        `,
      $isDisabled &&
        $hasSelectedItem &&
        css`
          color: ${select.button.text.color.disabled};
        `,
    ];
  }}
`;

export const ListItem = styled.li`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return [
      css`
        all: unset;
        box-sizing: border-box;
        display: grid;
        min-height: ${select.menu.option.minHeight};
        padding: ${select.menu.option.padding};
        background: ${select.menu.option.backgroundColor.base};
        cursor: pointer;
      `,
    ];
  }}
`;

type ListItemContentWrapperProps = {
  $isSelected: boolean;
  $isHighlighted: boolean;
};

export const ListItemContentWrapper = styled.div<ListItemContentWrapperProps>`
  ${({ $isSelected, $isHighlighted }) => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return [
      css`
        display: grid;
        align-items: center;
        color: ${select.menu.option.inner.color.base};
        padding-top: ${select.menu.option.inner.padding.top};
        padding-left: ${select.menu.option.inner.padding.left};
        padding-right: ${select.menu.option.inner.padding.right};
        padding-bottom: ${select.menu.option.inner.padding.bottom};
        border-radius: ${select.menu.option.inner.radius};
        background: ${select.menu.option.inner.backgroundColor.base};
        outline-width: ${select.menu.option.inner.stroke.width};
        outline-style: ${select.menu.option.inner.stroke.style};
        outline-color: ${select.menu.option.inner.stroke.color.base};
        outline-offset: ${select.menu.option.inner.stroke.offset};

        &:active {
          background: ${select.menu.option.inner.backgroundColor.active};
          outline-color: ${select.menu.option.inner.stroke.color.active};
        }
      `,
      $isSelected &&
        css`
          background: ${select.menu.option.inner.backgroundColor.selected};
          outline-color: ${select.menu.option.inner.stroke.color.selected};
        `,
      $isHighlighted &&
        css`
          background: ${select.menu.option.inner.backgroundColor.hover};
          outline-color: ${select.menu.option.inner.stroke.color.hover};
        `,
    ];
  }}
`;

export const ListItemContent = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return [
      css`
        display: grid;
        grid-template-columns: auto 1fr;
        gap: ${select.menu.option.inner.gap};
        overflow-wrap: anywhere;
      `,
    ];
  }}
`;

export const ListItemTickIconWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return [
      css`
        display: grid;
        place-items: center;
        width: ${select.menu.option.inner.tickIconWrapper.width};
        height: ${parseSizeToken(
          select.menu.option.inner.tickIconWrapper.height
        )};
      `,
    ];
  }}
`;

export const ListItemTickIcon = styled(TickIcon)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return [
      css`
        width: ${select.menu.option.inner.tickIcon.width};
        height: ${select.menu.option.inner.tickIcon.height};
        color: ${select.menu.option.inner.tickIcon.color};
      `,
    ];
  }}
`;
